export const text ={
    title:'Forgot Password ?',
    heading:'If you forgot your password, well, then we’ll email you instructions to reset your password.',
}